import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../models/report.model';
import { environment } from '@perval/shared';

@Component({
  selector: 'app-votre-estimation',
  templateUrl: './votre-estimation.component.html',
  styleUrls: ['./votre-estimation.component.scss'],
})
export class VotreEstimationComponent implements OnChanges {
  @Input() appraisal!: Report.Appraisal;
  @Input() isLoading = false;
  @Input() reportType!: string;
  @Input() historyLegacyId!: string;

  appraisalInternal!: Report.Appraisal;

  @Output() appraisalChanged = new EventEmitter<Report.Appraisal.BasicInfo>();
  @Output() appraisalEnabled = new EventEmitter<boolean>();
  @Output() cancled = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appraisal']) {
      this.appraisalInternal = this.appraisal;
    }
  }

  onBasicInfosChanged(basicInfo: Report.Appraisal.BasicInfo): void {
    this.appraisalInternal = {
      ...this.appraisalInternal,
      basicInfo: { ...basicInfo },
    };
  }

  onSaveSection(): void {
    this.appraisalChanged.emit(this.appraisalInternal.basicInfo);
  }

  onEnabled(isEnabled: boolean): void {
    this.appraisalEnabled.emit(isEnabled);
  }

  onCancled(): void {
    this.appraisalInternal = structuredClone(this.appraisal);
  }

  onRedirectToReferences(): void {
    window.open(
      `${environment.host}/recherche-references/achat/${this.historyLegacyId}`,
      '_blank',
      'noopener,noreferrer',
    );
  }
}
